var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"text-center cardModel"},[_c('div',{staticClass:"sous-card",class:{ loaderData: _vm.loaderData }},[_vm._t("header"),_vm._t("title"),_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }